window.eviivo = window.eviivo ? window.eviivo : {};
window.eviivo.myweb = window.eviivo.myweb ? window.eviivo.myweb : {};
window.eviivo.myweb.auth = window.eviivo.myweb.auth ? window.eviivo.myweb.auth : {};
window.eviivo.myweb.auth.secure = window.eviivo.myweb.auth.secure ? window.eviivo.myweb.auth.secure : {};

window.eviivo.myweb.auth.secure.login = function () {
    const init = () => {
        bindEventHandlers();
        initLanguageSwitcher();

        if (typeof $ !== 'undefined' && typeof $.fn.tooltip === "function") {
            // Lazy initialization: only initialize tooltips on first hover
            $(document).on('mouseenter', '.cp-tip', function(e) {
                const $this = $(this);
                
                // Only initialize once (check for existing ui-tooltip data)
                if (!$this.data('ui-tooltip')) {
                    $this.tooltip({
                        position: {
                            my: "center bottom-15",
                            at: "center top",
                            using: function (position, feedback) {
                                $(this).css(position);
                                $("<div>")
                                    .addClass("arrow")
                                    .addClass(feedback.vertical)
                                    .addClass(feedback.horizontal)
                                    .appendTo(this);
                            }
                        }
                    });
                    
                    // Open immediately after initialization
                    $this.tooltip('open');
                }
            });
            
            $(document).on('mouseleave', '.cp-tip', function(e) {
                $(this).tooltip('close');
            });
        }
    };

    const bindEventHandlers = () => {
        const helpTrigger = document.querySelector('.guest-login-help-trigger');
        const helpClose = document.querySelector('.guest-login-help-close');
        const helpSection = document.querySelector('.guest-login-help');
        const ownerFullLoginSubmitButton = document.querySelector('.owner-full-login-submit');
        const body = document.body;

        if (helpTrigger) {
            helpTrigger.addEventListener('click', function (e) {
                e.preventDefault();
                helpSection.style.display = 'flex';
                body.style.overflow = 'hidden';
            });
        }

        if (helpClose) {
            helpClose.addEventListener('click', function (e) {
                e.preventDefault();
                helpSection.style.display = 'none';
                body.style.overflow = 'auto';
            });
        }

        if (ownerFullLoginSubmitButton) {
            ownerFullLoginSubmitButton.addEventListener('click', function (e) {
                e.preventDefault();

                window.location.href = ownerFullLoginSubmitButton.getAttribute('data-url');
            });
        }
    }

    // =============================================================================
    // LANGUAGE SWITCHER
    // =============================================================================

    /**
     * Initializes language switcher dropdowns with toggle and click-outside behavior
     * Supports multiple switchers on the same page with smooth slide-down animations
     */
    function initLanguageSwitcher() {
        const switchers = document.querySelectorAll('.language-switcher');

        switchers.forEach(switcher => {
            const trigger = switcher.querySelector('.language-switcher-trigger');
            const list = switcher.querySelector('.language-switcher-list');

            if (!trigger || !list) {
                return;
            }

            list.querySelectorAll('.language-switcher-option').forEach(option => {
                option.addEventListener('click', async (event) => {
                    event.preventDefault();

                    const cultureCode = option.dataset.lang;
                    const languageChangeUrl = list.dataset.languageChangeUrl;
                    if (!cultureCode || !languageChangeUrl) {
                        return;
                    }

                    try {
                        const response = await fetch(languageChangeUrl, {
                            method: 'POST',
                            body: new URLSearchParams({ cultureCode })
                        });

                        if (!response.ok) {
                            throw new Error(`Language change failed with status ${response.status}.`);
                        }

                        const data = await response.json();
                        if (data?.isSuccess === true) {
                            location.reload();
                        }
                    } catch (error) {
                        console.error('Unable to change language.', error);
                    }
                });
            });

            // Toggle list visibility on trigger click
            trigger.addEventListener('click', (e) => {
                e.stopPropagation();
                const isHidden = list.classList.contains('hidden');

                if (isHidden) {
                    // Show and animate in
                    list.classList.remove('hidden');
                    list.offsetHeight; // Trigger reflow for animation
                    list.classList.add('opacity-100', 'translate-y-0');
                } else {
                    // Animate out then hide
                    list.classList.remove('opacity-100', 'translate-y-0');
                    setTimeout(() => list.classList.add('hidden'), 200);
                }
            });

            // Close list when clicking outside
            document.addEventListener('click', (e) => {
                if (!switcher.contains(e.target)) {
                    list.classList.remove('opacity-100', 'translate-y-0');
                    setTimeout(() => list.classList.add('hidden'), 200);
                }
            });
        });
    }

    return {
        init: init
    }
}();
